/** @format */

import {safeDivide} from 'helpers/numberHelpers';

import {ChartsPredicateList, SecondaryPredicate} from '../models/complexCharts';

const baseSecondaryPredicate: SecondaryPredicate = (current, previous) => {
  return current + previous;
};

export const CHARTS_PREDICATES: ChartsPredicateList = {
  budget: {
    secondaryPredicate: baseSecondaryPredicate,
  },
  shows: {
    secondaryPredicate: baseSecondaryPredicate,
  },
  clicks: {
    secondaryPredicate: baseSecondaryPredicate,
  },
  income: {
    secondaryPredicate: baseSecondaryPredicate,
  },
  reach: {
    secondaryPredicate: baseSecondaryPredicate,
  },
  conversions: {
    secondaryPredicate: baseSecondaryPredicate,
  },

  // https://www.notion.so/1e3b5f12da61808ea75beff52f671469?source=copy_link#1e3b5f12da618090abebeb4dfcfb3e47

  cpl: {
    forecastPredicate: ({rangeA, rangeB}) => {
      const min = safeDivide(rangeA[0], rangeB[1]);
      const max = safeDivide(rangeA[1], rangeB[0]);
      return [min, max];
    },
    forecastDataA: 'budget',
    forecastDataB: 'conversions',
  },

  cpc: {
    forecastPredicate: ({rangeA, rangeB}) => {
      const min = safeDivide(rangeA[0], rangeB[1]);
      const max = safeDivide(rangeA[1], rangeB[0]);
      return [min, max];
    },
    forecastDataA: 'budget',
    forecastDataB: 'clicks',
  },

  cpm: {
    forecastPredicate: ({rangeA, rangeB}) => {
      const min = safeDivide(rangeA[0], rangeB[1]) * 1000;
      const max = safeDivide(rangeA[1], rangeB[0]) * 1000;
      return [min, max];
    },
    forecastDataA: 'budget',
    forecastDataB: 'shows',
  },

  avgVideoCompleteCost: {
    forecastPredicate: ({rangeA, rangeB}) => {
      const min = safeDivide(rangeA[0], rangeB[1]);
      const max = safeDivide(rangeA[1], rangeB[0]);
      return [min, max];
    },
    forecastDataA: 'budget',
    forecastDataB: 'videoComplete',
  },

  drr: {
    forecastPredicate: ({rangeA, rangeB}) => {
      const min = safeDivide(rangeA[0], rangeB[1]) * 100;
      const max = safeDivide(rangeA[1], rangeB[0]) * 100;
      return [min, max];
    },
    forecastDataA: 'budget',
    forecastDataB: 'income',
  },

  romi: {
    forecastPredicate: ({rangeA, rangeB}) => {
      const min = safeDivide(rangeA[0], rangeB[1]) * 100;
      const max = safeDivide(rangeA[1], rangeB[0]) * 100;
      return [min, max];
    },
    forecastDataA: 'income',
    forecastDataB: 'budget',
  },

  ctr: {
    forecastPredicate: ({rangeA, rangeB}) => {
      const min = safeDivide(rangeA[0], rangeB[1]) * 100;
      const max = safeDivide(rangeA[1], rangeB[0]) * 100;
      return [min, max];
    },
    forecastDataA: 'clicks',
    forecastDataB: 'shows',
  },

  er: {
    forecastPredicate: ({rangeA, rangeB}) => {
      const min = safeDivide(rangeA[0], rangeB[1]) * 100;
      const max = safeDivide(rangeA[1], rangeB[0]) * 100;
      return [min, max];
    },
    forecastDataA: 'engagement',
    forecastDataB: 'reach',
  },

  vtr: {
    forecastPredicate: ({rangeA, rangeB}) => {
      const min = safeDivide(rangeA[0], rangeB[1]) * 100;
      const max = safeDivide(rangeA[1], rangeB[0]) * 100;
      return [min, max];
    },
    forecastDataA: 'videoComplete',
    forecastDataB: 'shows',
  },

  declines: {
    forecastPredicate: ({rangeA, rangeB}) => {
      const min = safeDivide(rangeA[0], rangeB[1]) * 100;
      const max = safeDivide(rangeA[1], rangeB[0]) * 100;
      return [min, max];
    },
    forecastDataA: 'bounces',
    forecastDataB: 'sessions',
  },
};
